import { ValidateIf } from 'class-validator';
export const IsNullable = () => {
    return ValidateIf((_, value) => value !== null);
};
